import { useLocalization } from "@fluent/react";
import { Button, Tooltip } from "@narmi/design_system";
import { useCurrentUser } from "../contexts/CurrentUserContext";
import { useUserFeatures } from "../contexts/UserFeaturesContext";

const AdvancedExportLink = () => {
  const { l10n } = useLocalization();
  const { currentUser } = useCurrentUser();
  const features = useUserFeatures();

  if (!features.reports || !currentUser?.isBusiness()) {
    return null;
  }

  return (
    <>
      <Button
        as="a"
        href="/reports"
        kind="plain"
        label={l10n.getString("transactions-card-advanced-export")}
        testId="advanced-export-link"
      />
      <Tooltip
        text={l10n.getString("transactions-card-advanced-export-tooltip")}
      >
        <span className="narmi-icon-info fontSize--xs fontColor--pine margin--left--xxs" />
      </Tooltip>
    </>
  );
};

export default AdvancedExportLink;
